import { render, staticRenderFns } from "./SubsetPopup.vue?vue&type=template&id=a313d7f2"
import script from "./SubsetPopup.vue?vue&type=script&lang=js"
export * from "./SubsetPopup.vue?vue&type=script&lang=js"
import style0 from "./SubsetPopup.vue?vue&type=style&index=0&id=a313d7f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports